import SweetAlert from "react-bootstrap-sweetalert";
import remove from "../../../assets/images/remove.png"

const DeleteModal = (props) => {
    const {onClickDeleteModel, deleteUserClick} = props;
  return (
    <SweetAlert
      custom
      confirmBtnBsStyle="danger mb-3 fs-5 rounded"
      cancelBtnBsStyle="secondary mb-3 fs-5 rounded text-white"
      confirmBtnText="Yes, Delete"
      cancelBtnText="No, Cancel"
      title="Delete"
      onConfirm={deleteUserClick}
      onCancel={onClickDeleteModel}
      showCancel
      focusCancelBtn
      customIcon={remove}
    >
      <span className="sweet-text">
        Are you sure want to delete this business ?
      </span>
    </SweetAlert>
  );
};

export default DeleteModal;
